import React, { useEffect, useState } from 'react';
import Navbar from '../components/navbar';
import EyeIcon from '../components/icons/eye';

import { observer, observable, action } from '@poa/state';

import '../styles/components/profile-page.scss';
import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';

import classNames from 'classnames';
import { env } from '../env';
import PaymentStaff from '../components/staff/payment-staff';
import moment from 'moment';
import { Observer } from 'mobx-react';
import { SingleDatePicker } from 'react-dates';


class PasswordField extends React.Component {
  static defaultProps = {
    name: 'auth_password',
    placeholder: 'password'
  };

  isPasswordVisible = observable(false);

  togglePasswordVisibility = action(() =>
    this.isPasswordVisible.set(!this.isPasswordVisible.get())
  );

  render() {
    return (
      <div className='main-form__input main-form__pass'>
        <input
          {...this.props}
          type={this.isPasswordVisible.get() ? 'text' : 'password'}
          name={this.props.name}
          placeholder={this.props.placeholder}
          data-test-id={this.props.testId}
        />

        <button
          type='button'
          className='main-form__icon'
          onMouseDown={this.togglePasswordVisibility}
          onMouseUp={this.togglePasswordVisibility}
        >
          <EyeIcon />
        </button>
      </div>
    );
  }
}

PasswordField = observer(PasswordField);

const ProfilePage = () => {
  const [tabActive, setTabActive] = useState('card');
  const [oldPassword, setOlPassword] = useState('');
  const [updatedWeekend, setUpdatedWeekend] = useState();
  const [newRepeatPassword, setNewRepeatPassword] = useState('');
  const [newPasswordValue, setNewPasswordValue] = useState('');
  const [passwordError, setPasswordError] = useState(null);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [userWeekends, setUserWeekends] = useState([]);
  const [isUpdateDatePickerOpen, setUpdateDatePickerOpen] = useState([]);

  const sideBarElemCardIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'card'
  });

  const sideBarElemChangePasswordIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'change-password'
  });

  const sideBarElemWeekendIsActiveClass = classNames('profile-page-sidebar-elem', {
    'profile-page-sidebar-elem--active': tabActive === 'weekend'
  });

  const handleUpdateDatePickerOpen = (weekendId) => {
    if (isUpdateDatePickerOpen.includes(weekendId)) {
      setUpdateDatePickerOpen(isUpdateDatePickerOpen.filter(id => id !== weekendId));
    } else {
      setUpdateDatePickerOpen([...isUpdateDatePickerOpen, weekendId]);
    }
  };

  const handleWeekendAdd = async () => {
    if (!selectedDate)
      return env.alert('Ошибка', `Пожалуйста выберите дату выходного дня`);

    try {
      const data = await env.http
        .post('staff/profile/weekend', {
          weekendDate: selectedDate
        })
        .then(response => response.data);
      setUserWeekends(data);
      env.alert('Успех', `Данные успешно сохранены`);
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не сохранились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const handleWeekendDelete = async (weekendId) => {
    try {
      const data = await env.http
        .delete(`staff/profile/weekend/${weekendId}`)
        .then(response => response.data);
      setUserWeekends(data);
      env.alert('Успех', `Данные успешно удалены`);
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не удалились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const onDateChange = event => {
    setSelectedDate(moment(event._d));
  };

  const onEditWeekendChange = (weekendId) => {
    if (weekendId !== updatedWeekend) {
      setUpdatedWeekend(weekendId);
      setSelectedDate(moment(userWeekends.find(weekend => weekend.id === weekendId).day, 'YYYYMMDD'));
    } else {
      setUpdatedWeekend(null);
      setSelectedDate(null);
    }
  };

  const handleWeekendUpdate = async (weekendId) => {
    try {
      const data = await env.http
        .patch(`staff/profile/weekend`, {
          weekendDate: selectedDate,
          weekendId: weekendId
        })
        .then(response => response.data);
      setUserWeekends(data);
      setUpdatedWeekend(null);
      setSelectedDate(null);
      setUpdateDatePickerOpen(isUpdateDatePickerOpen.filter(id => id !== weekendId));
      env.alert('Успех', `Данные успешно обновлены`);
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const handleWeekendCancel = (weekendId) => {
    setUpdatedWeekend(null);
    setSelectedDate(null);
    setUpdateDatePickerOpen(isUpdateDatePickerOpen.filter(id => id !== weekendId));
  }

  const getUserWeekends = () => {
    env.http.get('staff/profile/weekend').then(response => {
      setUserWeekends(response.data);
    });
  };

  useEffect(() => {
    getUserWeekends();
  }, []);

  return (
    <div className='profile-page'>
      <Navbar />

      <div className='profile-page__container'>
        <div className='profile-page-sidebar'>
          <div className='profile-page-sidebar__title profile-page__headline-title'>Меню</div>
          <div className='profile-page-sidebar-list'>
            <div className={sideBarElemCardIsActiveClass} onClick={() => setTabActive('card')}>
              <div className='profile-page-sidebar-elem__icon'>
                <svg
                  width='12'
                  height='14'
                  viewBox='0 0 12 14'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8.94946 2.70801C8.53812 1.52001 7.40946 0.666681 6.08146 0.666681C4.40612 0.660014 3.04212 2.01201 3.03479 3.68735V3.70068V5.13201'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.622 13.0003H3.528C2.132 13.0003 1 11.8683 1 10.4716V7.61294C1 6.21627 2.132 5.08427 3.528 5.08427H8.622C10.018 5.08427 11.15 6.21627 11.15 7.61294V10.4716C11.15 11.8683 10.018 13.0003 8.622 13.0003Z'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M6.07503 8.30174V9.78308'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>

              <div className='profile-page-sidebar-elem__text'>Реквизиты для выплаты</div>
            </div>

            <div
              className={sideBarElemChangePasswordIsActiveClass}
              onClick={() => setTabActive('change-password')}
            >
              <div className='profile-page-sidebar-elem__icon'>
                <svg
                  width='15'
                  height='14'
                  viewBox='0 0 15 14'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M13.4259 9.09717H10.7271C9.73611 9.09656 8.93289 8.29395 8.93228 7.30299C8.93228 6.31202 9.73611 5.50941 10.7271 5.5088H13.4259'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M4.1651 1.5H9.92738C11.8595 1.5 13.4258 3.06634 13.4258 4.99844V9.78313C13.4258 11.7152 11.8595 13.2816 9.92738 13.2816H4.1651C2.233 13.2816 0.666656 11.7152 0.666656 9.78313V4.99844C0.666656 3.06634 2.233 1.5 4.1651 1.5Z'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M3.6904 4.52544H7.2897'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>

              <div className='profile-page-sidebar-elem__text'>Смена пароля</div>
            </div>

            <div
              className={sideBarElemWeekendIsActiveClass}
              onClick={() => setTabActive('weekend')}
            >
              <div className='profile-page-sidebar-elem__icon'>
                <svg
                  width='15'
                  height='14'
                  viewBox='0 0 15 14'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M13.4259 9.09717H10.7271C9.73611 9.09656 8.93289 8.29395 8.93228 7.30299C8.93228 6.31202 9.73611 5.50941 10.7271 5.5088H13.4259'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M4.1651 1.5H9.92738C11.8595 1.5 13.4258 3.06634 13.4258 4.99844V9.78313C13.4258 11.7152 11.8595 13.2816 9.92738 13.2816H4.1651C2.233 13.2816 0.666656 11.7152 0.666656 9.78313V4.99844C0.666656 3.06634 2.233 1.5 4.1651 1.5Z'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M3.6904 4.52544H7.2897'
                    stroke='#828282'
                    strokeWidth='1.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>

              <div className='profile-page-sidebar-elem__text'>Выходной</div>
            </div>
          </div>
        </div>

        <div className='profile-page-info'>
          {tabActive === 'card' && (
            <>
              <div className='profile-page__headline-title'>Основная информация</div>

              <PaymentStaff userId={'self'} />
            </>
          )}

          {tabActive === 'change-password' && (
            <>
              <div className='profile-page__headline-title profile-page__headline-title-change-password'>
                Смена пароля
              </div>

              <PasswordField
                name='oldPassword'
                placeholder='Старый пароль'
                value={oldPassword}
                onChange={e => {
                  setOlPassword(e.target.value);
                }}
                onFocus={() => setPasswordError(null)}
              />

              <PasswordField
                name='newRepeatPassword'
                placeholder='Новый пароль'
                value={newPasswordValue}
                onChange={e => {
                  setNewPasswordValue(e.target.value);
                }}
                onFocus={() => setPasswordError(null)}
              />

              <PasswordField
                name='oldPassword'
                placeholder='Повтор пароля'
                value={newRepeatPassword}
                onChange={e => {
                  setNewRepeatPassword(e.target.value);
                }}
                onFocus={() => setPasswordError(null)}
              />

              {passwordError && <div className='profile-page__input--error'>{passwordError}</div>}

              <LaddaButton
                className='main-form__submit'
                type='submit'
                data-test-id='submitButton'
                data-color='#eee'
                data-size={XL}
                data-style={SLIDE_UP}
                data-spinner-size={30}
                data-spinner-color='#ddd'
                data-spinner-lines={12}
                onClick={() => {
                  if (oldPassword === '' || newRepeatPassword === '' || newPasswordValue === '')
                    return setPasswordError('Пожалуйста заполните все поля');
                  if (newPasswordValue !== newRepeatPassword)
                    return setPasswordError('Пароли не совпадают');
                  env.http
                    .post('staff/password/change/', {
                      newPassword: newPasswordValue,
                      oldPassword: oldPassword
                    })
                    .then(
                      (response, reject) => {
                        setNewPasswordValue('');
                        setOlPassword('');
                        setNewRepeatPassword('');
                      },
                      reject => {
                        env.alert(
                          'Успех',
                          `Ошибка. Данные не сохранились. <br/>Обратитесь с администратору <br /><br /> Тип ошибки: ${reject}`
                        );
                      }
                    );

                  env.alert('Успех', `Данные успешно сохранены`);
                }}
              >
                Обновить пароль
              </LaddaButton>
            </>
          )}

          {tabActive === 'weekend' && (
            <>
              <div className='profile-page__headline-title profile-page__headline-title-change-password'>
                Выбрать выходной
              </div>

              <div>
                <h3>Ближайшие выходные :</h3>

                {userWeekends.map((weekend, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                    <p key={index}>{moment(weekend.day, 'YYYYMMDD').format('DD.MM.YYYY')}</p>
                    {(updatedWeekend !== weekend.id) && (
                      <>
                        <button
                          className='popup__btn popup__btn_cancel js-popup-edit-cancel'
                          onClick={() => handleWeekendDelete(weekend.id)}
                        >
                          <svg
                            className='icon icon-cancel'
                            id='icon-cancel'
                            viewBox='0 0 15.5 15.5'
                            width='100%'
                            height='100%'
                          >
                            <path
                              d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z' />
                            <path
                              strokeMiterlimit='50'
                              strokeWidth='.5'
                              d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z'
                            />
                          </svg>
                        </button>
                        <button className='popup__btn popup__btn_edit js-popup-edit'
                                onClick={() => onEditWeekendChange(weekend.id)}>
                          <svg
                            className='icon icon-pencil-black'
                            id='icon-pencil'
                            viewBox='0 0 15 15'
                            width='100%'
                            height='100%'
                          >
                            <path
                              d='M8.71 2.34l2.84 2.86-7.21 7.24L1.5 9.58zm5 .69L12.3 4.45 9.45 1.59 10.66.37c.5-.49 1.29-.49 1.78 0l1.27 1.28c.39.38.39 1 0 1.38zM.01 13.6c-.05.24.16.45.39.39l3.17-.77-2.84-2.86z' />
                          </svg>
                        </button>
                      </>
                    )}
                    {
                      (updatedWeekend === weekend.id) && (
                        <Observer>
                          {() => (
                            <>
                              <div className='picker-wrapper'>
                                <SingleDatePicker
                                  block
                                  isOutsideRange={() => false}
                                  placeholder='Виберите дату'
                                  focused={isUpdateDatePickerOpen.includes(weekend.id)}
                                  date={selectedDate}
                                  onDateChange={onDateChange}
                                  onFocusChange={() => handleUpdateDatePickerOpen(weekend.id)}
                                />
                              </div>

                              <button
                                className='popup__btn popup__btn_save js-popup-edit-save'
                                onClick={() => handleWeekendUpdate(weekend.id)}
                              >
                                <svg
                                  className='icon icon-like'
                                  id='icon-like'
                                  viewBox='0 0 14.53 10'
                                  width='100%'
                                  height='100%'
                                >
                                  <path
                                    d='M12.74 1.18a.6.6 0 0 0-.86 0L4.6 8.46l-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z' />
                                  <path
                                    strokeMiterlimit='50'
                                    strokeWidth='2'
                                    d='M1239.98 296.18a.6.6 0 0 0-.86 0l-7.28 7.28-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z'
                                    clipPath='url(&quot;#a&quot;)'
                                    transform='translate(-1227.24 -295)'
                                  />
                                </svg>
                              </button>

                              <button
                                className='popup__btn popup__btn_cancel js-popup-edit-cancel'
                                onClick={() => handleWeekendCancel(weekend.id)}
                              >
                                <svg
                                  className='icon icon-cancel'
                                  id='icon-cancel'
                                  viewBox='0 0 15.5 15.5'
                                  width='100%'
                                  height='100%'
                                >
                                  <path
                                    d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z' />
                                  <path
                                    strokeMiterlimit='50'
                                    strokeWidth='.5'
                                    d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z'
                                  />
                                </svg>
                              </button>
                            </>
                          )}
                        </Observer>
                      )
                    }
                  </div>
                ))}
              </div>

              <br />
              <br />

              <Observer>
                {() => (
                  <div className='picker-wrapper'>
                    Добавить выходной:
                    <br />
                    <SingleDatePicker
                      block
                      isOutsideRange={() => false}
                      placeholder='Виберите дату'
                      focused={isDatePickerOpen}
                      date={selectedDate}
                      onDateChange={onDateChange}
                      onFocusChange={() => setDatePickerOpen(!isDatePickerOpen)}
                    />
                  </div>
                )}
              </Observer>
              <LaddaButton
                className='main-form__submit'
                type='submit'
                data-test-id='submitButton'
                data-color='#eee'
                data-size={XL}
                data-style={SLIDE_UP}
                data-spinner-size={30}
                data-spinner-color='#ddd'
                data-spinner-lines={12}
                onClick={handleWeekendAdd}
              >
                Добавить выходной
              </LaddaButton>
            </>
          )}
        </div>
      </div>
    </div>
  )
    ;
};

export default ProfilePage;
